import React from 'react';
import { TONES, statusTone, statusLabel } from '../../design/tokens';
import './ui.css';

/**
 * Status pill — 11.5px/600, padding 3px 9px, radius 6px.
 * Pass either an explicit `tone`, or a raw backend `status` to have the tone inferred.
 */
export default function StatusPill({ status, tone, children, className = '' }) {
  const resolved = tone || statusTone(status);
  const palette = TONES[resolved] || TONES.neutral;

  return (
    <span
      className={`sv-pill ${className}`}
      style={{ background: palette.bg, color: palette.color }}
    >
      {children != null ? children : statusLabel(status)}
    </span>
  );
}
